/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBellRing: {
  name: 'bell-ring';
  data: string;
} = {
  name: 'bell-ring',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.224 1.447a.5.5 0 1 0-.447-.894l-2 1a.5.5 0 1 0 .447.894l2-1Zm6-.894a.5.5 0 1 0-.447.894l2 1a.5.5 0 1 0 .447-.894l-2-1ZM6 12.5h6.191l-.533-1.065a1.499 1.499 0 0 1-.158-.671V7a3.5 3.5 0 1 0-7 0v3.764a1.5 1.5 0 0 1-.158.67L3.809 12.5H6Zm4.45 1H13a.5.5 0 0 0 .447-.724l-.894-1.788a.5.5 0 0 1-.053-.224V7a4.5 4.5 0 1 0-9 0v3.764a.5.5 0 0 1-.053.224l-.894 1.788A.5.5 0 0 0 3 13.5h2.55a2.5 2.5 0 0 0 4.9 0Zm-1.035 0a1.5 1.5 0 0 1-2.83 0h2.83Z" fill="currentColor"/></svg>`,
};
